import axios from 'axios'

export default {
  state: {
    intensives_list: null,
    intensive_detail: null,
    intensive_total_progress: [],
  },
  getters: {
    getIntensiveList: (s) => s.intensives_list,
    getIntensiveDetail: (s) => s.intensive_detail,
    getIntensiveTotalProgress: (s) => s.intensive_total_progress,
  },
  mutations: {
    setIntensiveList: (s, list) =>
      (s.intensives_list = list.filter((el) => el.translates.length)),
    setIntensiveDetail: (s, detail) => (s.intensive_detail = detail),
    setTotalProgress: (s, progress) => (s.intensive_total_progress = progress),
  },
  actions: {
    fetchIntensiveList(ctx, lang = 'ru') {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/intensives/items/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data.results
          ctx.commit('setIntensiveList', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
    fetchIntensiveDetail(ctx, { lang = 'ru', slug }) {
      // if (lang === 'be') lang = 'ru';
      return axios({
        method: 'GET',
        url: `api/v3/intensives/items/${slug}/?language=${lang}`,
      })
        .then((response) => {
          const list = response.data
          ctx.commit('setIntensiveDetail', list)
        })
        .catch((error) => {
          if (error && error.response && error.response.status) {
            ctx.commit('setIntensiveDetail', error.response.status)
          } else {
            ctx.commit('setIntensiveDetail', 404)
          }
          console.error(error)
        })
    },
    IntensiveSetVideoProgress(ctx, { id, progress }) {
      const fd = new FormData()
      fd.append('progress', progress)
      return axios({
        method: 'POST',
        data: fd,
        url: `/api/v3/intensives/lessons/${id}/progress/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    IntensiveSetLike(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/lessons/${id}/like/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    IntensiveSetFavorite(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/lessons/${id}/favorite/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    IntensiveSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/lessons/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    IntensiveTestSetView(ctx, id) {
      return axios({
        method: 'POST',
        url: `/api/v3/intensives/lessons/tests/${id}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
    IntensivesTotalProgress(ctx) {
      return axios({
        method: 'GET',
        url: `/api/v3/intensives/items/total-progress/`,
      })
        .then((response) => {
          const progress = response.data
          ctx.commit('setTotalProgress', progress)
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
